import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const indoorPlay2YearsOld: BlogMetaData = {
  title: '2歳児の室内遊び15選｜家でできる・発達別に選ぶコツとモンテッソーリ流のポイント',
  description:
    '2歳児の室内遊びを15選厳選。家でできる運動・製作・感覚遊び・ごっこ遊びを発達段階別に整理し、モンテッソーリ流の選び方と雨の日もすぐ使えるアイデアをセットで解説します。',
  thumbnailUrl: '/img/blog-indoor-play-2-years-old.webp',
  filePath: buildBlogFilePath('indoor-play-2-years-old'),
  category: BLOG_CATEGORY.PLAY_TOOLS,
};
